export const isObject = (item: any) => {
  return item && typeof item === 'object' && !Array.isArray(item)
}

// @ts-ignore
export const mergeDeep = (custom, original) => {
  const target = Object.assign({}, custom)
  const sources = Object.assign({}, original)
  return [{}, sources, target].reduce(merge)
}

const merge = (a: any, b: any) => {
  return Object.entries(b).reduce((o, [k, v]) => {
    o[k] = v && typeof v === 'object' ? merge((o[k] = o[k] || (Array.isArray(v) ? [] : {})), v) : v
    return o
  }, a)
}
